<template>
    <div class="privacyManagementDetail">
         <van-nav-bar
            :title="title"
            left-text=""
            left-arrow
            class="main-nav"
            @click-left="onClickLeft"
        />
        <div class="privacyManagementDetail_list">
            <div class="privacyManagementDetail_list_top">
                <p>测试中心</p>
                <van-switch v-model="checked" size="24px" @change="switchChange" class="privacyManagementDetail_list_switch" />
            </div>
            <van-cell title="隐私密码" is-link class="privacyManagementDetail_list_top_cell" :value="ifHasPasswors" @click="goPassword" />
            <van-cell title="找回隐私密码" is-link class="privacyManagementDetail_list_top_cell"  v-if="ifHasPasswors == '已设置'" @click="gofindPassword" />
        </div>
    </div>
</template>
<script>
import {_checkPrivacyEnable,_setPrivacyEnable,_checkParentPasswordExist,_checkStudentPasswordExist,_checkStudentPrivacyEnable,_setStudentPrivacyEnable} from '../../api/test-center'
import {verticalScreen} from '../../assets/js/vertical-screen';
export default {
    name: 'privacy-management-detail',
    data() {
        return {
            title:'',
            flag:'',
            checked:true,
            ifHasPasswors:''
        }
    },
    created() {
        this.title = this.$route.query.title;
        this.flag = this.$route.query.flag;
        if(this.flag == 1) {
            this.checkPrivacyEnable();
            this.checkParentPasswordExist();
        } else {
            this.checkStudentPasswordExist();
            this.checkStudentPrivacyEnable();
        }

    },
    mounted() {
        verticalScreen();
    },
    methods: {
         onClickLeft() {
            this.$router.go(-1);
        },
        //点击隐私密码
        goPassword() {
            if(this.ifHasPasswors == '未设置') {
                this.$router.replace({
                    path:'/privacyPassword',
                    query:{
                        status: this.flag
                    }
                })
            } else {
                let flagNum;
                if( this.flag == 1) {
                    flagNum = 5;
                } else {
                    flagNum = 6;
                }
                this.$router.replace({
                    path:'/privacyPassword',
                    query:{
                        status: flagNum
                    }
                })
            }
        },
        //找回隐私密码
        gofindPassword() {
            let flagNumber;
            if( this.flag == 1) {
                flagNumber = 7;
            } else {
                flagNumber = 8;
            }
             this.$router.replace({
                path:'/privacyPassword',
                query:{
                    status: flagNumber
                }
            })
        },
        switchChange(value) {
            this.checked = value;
            if(this.flag == 1) {
                this.setPrivacyEnable();
            } else {
                this.setStudentPrivacyEnable();
            }
        },
        //查看家长隐私密码设置状态
        checkPrivacyEnable() {
            _checkPrivacyEnable().then((res)=>{
                if(res.code==200){
                    this.checked = res.data;
                }else{
                this.$toast(res.message)
                }
            })
        },
        //设置家长隐私密码设置状态
        setPrivacyEnable() {
            _setPrivacyEnable({
                privacyEnable:this.checked
            }).then((res)=>{
                if(res.code==200){

                }else{
                this.$toast(res.message)
                }
            })
        },
        //家长是否设置密码
        checkParentPasswordExist() {
            _checkParentPasswordExist().then((res)=>{
                if(res.code==200){
                    if(res.data) {
                        this.ifHasPasswors ='已设置';
                    } else {
                        this.ifHasPasswors ='未设置';
                    }
                }else{
                this.$toast(res.message)
                }
            })
        },
        //查看儿童隐私密码设置状态
        checkStudentPrivacyEnable() {
            _checkStudentPrivacyEnable(
                localStorage.getItem('childId')
            ).then((res)=>{
                if(res.code==200){
                    this.checked = res.data;
                }else{
                    this.$toast(res.message)
                }
            })
        },
        //设置儿童隐私密码设置状态
        setStudentPrivacyEnable() {
            _setStudentPrivacyEnable({
                userId:localStorage.getItem('childId'),
                privacyEnable:this.checked
            }).then((res)=>{
                if(res.code==200){
                }else{
                    this.$toast(res.message)
                }
            })
        },
         //儿童是否设置密码
        checkStudentPasswordExist() {
            _checkStudentPasswordExist(
                localStorage.getItem('childId')
            ).then((res)=>{
                if(res.code==200){
                    if(res.data) {
                        this.ifHasPasswors ='已设置';
                    } else {
                        this.ifHasPasswors ='未设置';
                    }
                }else{
                    this.$toast(res.message)
                }
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.privacyManagementDetail_list {
    .privacyManagementDetail_list_top {
        display: flex;
        justify-content: space-between;
        height: 56px;
        width: 345px;
        margin-left: 15px;
        border-bottom: solid 1px #ebedf0;
        p {
            line-height: 56px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #000000;
        }
        .privacyManagementDetail_list_switch {
            margin-top: 16.5px;
        }
    }
    .privacyManagementDetail_list_top_cell {
         height: 56px;
         line-height: 38px;
         ::v-deep .van-cell__right-icon {
             margin-top: 7px;
         }
    }
}
::v-deep .van-icon {
    color: #000;
}
</style>
